module.exports = __webpack_public_path__ + "static/working@large-ceb0c85dcf9ebfe3c376b583c4e8bebe.jpg";